import { render, staticRenderFns } from "./RewardCampaignItem.vue?vue&type=template&id=b5942888&scoped=true&"
import script from "./RewardCampaignItem.vue?vue&type=script&lang=js&"
export * from "./RewardCampaignItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardCampaignItem.vue?vue&type=style&index=0&id=b5942888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5942888",
  null
  
)

export default component.exports